export default __webpack_public_path__ + "static/media/Spinner-0.8s-200px.bde4ca3f.svg";